exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activeClass[data-v-0daaf644],.dark-color[data-v-0daaf644]{background-color:var(--dark-color)}.activeClass[data-v-0daaf644]{color:var(--white-color)!important}.list-group>.list-group-item[data-v-0daaf644]:hover{background-color:var(--dark-color);color:var(--white-color);cursor:pointer;border:1px solid var(--white-color)}.activeClass>.dark-color[data-v-0daaf644],.list-group>.list-group-item:hover>.dark-color[data-v-0daaf644]{background-color:var(--white-color);color:var(--dark-color)}.list-group-item[data-v-0daaf644]{font-weight:700;color:var(--dark-color);border-color:var(--dark-color)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0daaf644","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Menu.vue
// module id = 353
// module chunks = 0